import { Breadcrumbs as MuiBreadcrumbs, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export interface BreadcrumbItem {
  display: string;
  path: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  const navigate = useNavigate();

  return (
    <MuiBreadcrumbs aria-label='breadcrumb'>
      {items.map((item, idx) => (
        <Link
          key={idx}
          underline='hover'
          color='inherit'
          onClick={() => navigate(item.path)}
          sx={{ cursor: 'pointer' }}
        >
          {item.display}
        </Link>
      ))}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
